module.exports = __webpack_public_path__ + "img/shadows.e7c5489e.png";